/**
 * CheckoutSuccessPage - Purchase confirmation
 * 
 * Shows after successful $99 payment
 * Route: /checkout/success
 */
import React from 'react';
import { Button } from '../components/ui/button';
import { CheckCircle, Download, ArrowRight } from 'lucide-react';
import './CheckoutSuccessPage.css';

const CheckoutSuccessPage = ({ onOpenApp, onOpenDownloads }) => {
  return (
    <div className="checkout-success-page" data-testid="checkout-success-page">
      <div className="success-card">
        <div className="success-icon">
          <CheckCircle size={64} />
        </div>
        
        <h1>Purchase Confirmed</h1>
        
        <p className="success-message">
          Thank you for purchasing RISKEE.
        </p>
        
        <p className="success-detail">
          Your account has been activated.
        </p>
        
        <div className="success-version">
          <span className="version-label">Version:</span>
          <span className="version-value">RISKEE v1.0</span>
        </div>

        <div className="success-cta-group">
          <Button 
            size="lg" 
            className="success-cta-primary"
            onClick={onOpenDownloads}
            data-testid="open-downloads-btn"
          >
            <Download size={20} />
            Open Downloads
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            className="success-cta-secondary"
            onClick={onOpenApp}
            data-testid="open-app-btn"
          >
            Open RISKEE App
            <ArrowRight size={20} />
          </Button>
        </div>
      </div>

      {/* Footer */}
      <footer className="success-footer">
        <div className="footer-brand">
          <img src="/riskee_logo.png" alt="" className="footer-logo-img" />
          <span className="footer-logo-text">RISKEE</span>
        </div>
        <span className="footer-tagline">A Standards Protocol Platform</span>
      </footer>
    </div>
  );
};

export default CheckoutSuccessPage;
